module.exports = __webpack_public_path__ + "assets/images/238c28189d1387bc4f0f12b22445be34.jpg";